/**
 * @generated SignedSource<<c61f1acbd4d3634e1105e187af08ee18>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FeaturedEventsPaginationQuery$variables = {
  count?: number | null | undefined;
  cursor?: string | null | undefined;
  endDate?: string | null | undefined;
  eventTags?: ReadonlyArray<string | null | undefined> | null | undefined;
  id: string;
  memberId?: string | null | undefined;
  startDate?: string | null | undefined;
};
export type FeaturedEventsPaginationQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"FeaturedEventsFragment">;
  } | null | undefined;
};
export type FeaturedEventsPaginationQuery = {
  response: FeaturedEventsPaginationQuery$data;
  variables: FeaturedEventsPaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "count"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cursor"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endDate"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "eventTags"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "memberId"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startDate"
},
v7 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v10 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  {
    "kind": "Variable",
    "name": "dateGte",
    "variableName": "startDate"
  },
  {
    "kind": "Variable",
    "name": "dateLte",
    "variableName": "endDate"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  {
    "kind": "Literal",
    "name": "isFeatured",
    "value": true
  },
  {
    "kind": "Variable",
    "name": "tagIds",
    "variableName": "eventTags"
  }
],
v11 = [
  {
    "kind": "Variable",
    "name": "clientId",
    "variableName": "memberId"
  }
],
v12 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v14 = [
  (v13/*: any*/),
  (v9/*: any*/)
],
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "plural",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "FeaturedEventsPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v7/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "FeaturedEventsFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "FeaturedEventsPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v7/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          (v9/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v10/*: any*/),
                "concreteType": "EventConnection",
                "kind": "LinkedField",
                "name": "events",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "count",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Event",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v8/*: any*/),
                          {
                            "alias": null,
                            "args": (v11/*: any*/),
                            "kind": "ScalarField",
                            "name": "accessStatusForClient",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v11/*: any*/),
                            "kind": "ScalarField",
                            "name": "signUpStatusForClient",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "startOn",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "endOn",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "spotsAvailable",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v12/*: any*/),
                            "concreteType": "EventTagConnection",
                            "kind": "LinkedField",
                            "name": "tags",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EventTagEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "EventTag",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": (v14/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "tags(first:1000)"
                          },
                          {
                            "alias": null,
                            "args": (v12/*: any*/),
                            "concreteType": "EventSessionConnection",
                            "kind": "LinkedField",
                            "name": "eventSessions",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EventSessionEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "EventSession",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "startAt",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "endAt",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "displayTime",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "CourseConnection",
                                        "kind": "LinkedField",
                                        "name": "courses",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "CourseEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Course",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v9/*: any*/),
                                                  (v13/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "CourseBucket",
                                                    "kind": "LinkedField",
                                                    "name": "courseBucket",
                                                    "plural": false,
                                                    "selections": (v14/*: any*/),
                                                    "storageKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Event",
                                        "kind": "LinkedField",
                                        "name": "event",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "EventSeries",
                                            "kind": "LinkedField",
                                            "name": "eventSeries",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Facility",
                                                "kind": "LinkedField",
                                                "name": "facility",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "FacilityCopyOverrides",
                                                    "kind": "LinkedField",
                                                    "name": "copyOverrides",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "NounOverride",
                                                        "kind": "LinkedField",
                                                        "name": "course",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "singular",
                                                            "storageKey": null
                                                          },
                                                          (v15/*: any*/)
                                                        ],
                                                        "storageKey": null
                                                      }
                                                    ],
                                                    "storageKey": null
                                                  },
                                                  (v9/*: any*/)
                                                ],
                                                "storageKey": null
                                              },
                                              (v9/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          (v9/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v9/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "eventSessions(first:1000)"
                          },
                          {
                            "alias": null,
                            "args": (v11/*: any*/),
                            "concreteType": "EventSignUpWindow",
                            "kind": "LinkedField",
                            "name": "clientEligibleSignUpWindows",
                            "plural": true,
                            "selections": [
                              (v9/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "closesAt",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "opensAt",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EventSeries",
                            "kind": "LinkedField",
                            "name": "eventSeries",
                            "plural": false,
                            "selections": [
                              (v13/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "color",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Facility",
                                "kind": "LinkedField",
                                "name": "facility",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "FacilityCopyOverrides",
                                    "kind": "LinkedField",
                                    "name": "copyOverrides",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "NounOverride",
                                        "kind": "LinkedField",
                                        "name": "course",
                                        "plural": false,
                                        "selections": [
                                          (v15/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Department",
                                    "kind": "LinkedField",
                                    "name": "department",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "type",
                                        "storageKey": null
                                      },
                                      (v13/*: any*/),
                                      (v9/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v9/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Image",
                                "kind": "LinkedField",
                                "name": "image",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": "publicId",
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "renderingKey",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v9/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v10/*: any*/),
                "filters": [
                  "dateGte",
                  "isFeatured",
                  "dateLte",
                  "tagIds"
                ],
                "handle": "connection",
                "key": "FeaturedEventsFragment_events",
                "kind": "LinkedHandle",
                "name": "events"
              }
            ],
            "type": "Club",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "553930ad0f6c07e90ed32af56d956a98",
    "id": null,
    "metadata": {},
    "name": "FeaturedEventsPaginationQuery",
    "operationKind": "query",
    "text": "query FeaturedEventsPaginationQuery(\n  $count: Int\n  $cursor: String\n  $endDate: Date\n  $eventTags: [ID]\n  $memberId: ID\n  $startDate: Date\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...FeaturedEventsFragment\n    id\n  }\n}\n\nfragment EventCardWrapper on Event {\n  id\n  accessStatusForClient(clientId: $memberId)\n  signUpStatusForClient(clientId: $memberId)\n  startOn\n  endOn\n  spotsAvailable\n  tags(first: 1000) {\n    edges {\n      node {\n        name\n        id\n      }\n    }\n  }\n  eventSessions(first: 1000) {\n    edges {\n      node {\n        startAt\n        endAt\n        displayTime\n        courses {\n          edges {\n            node {\n              id\n              name\n              courseBucket {\n                name\n                id\n              }\n            }\n          }\n        }\n        ...useEventLocationLabel_Event\n        id\n      }\n    }\n  }\n  clientEligibleSignUpWindows(clientId: $memberId) {\n    id\n    closesAt\n    opensAt\n  }\n  eventSeries {\n    name\n    color\n    facility {\n      copyOverrides {\n        course {\n          plural\n        }\n      }\n      department {\n        type\n        name\n        id\n      }\n      id\n    }\n    image {\n      publicId: renderingKey\n    }\n    id\n  }\n}\n\nfragment FeaturedEventsFragment on Club {\n  events(first: $count, after: $cursor, dateGte: $startDate, isFeatured: true, dateLte: $endDate, tagIds: $eventTags) {\n    count\n    edges {\n      node {\n        id\n        __typename\n      }\n      cursor\n    }\n    ...FeaturedEventsScrollerEventConnection\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment FeaturedEventsScrollerEventConnection on EventConnection {\n  edges {\n    node {\n      id\n      ...EventCardWrapper\n    }\n  }\n}\n\nfragment useEventLocationLabel_Event on EventSession {\n  courses {\n    edges {\n      node {\n        name\n        courseBucket {\n          name\n          id\n        }\n        id\n      }\n    }\n  }\n  event {\n    eventSeries {\n      facility {\n        ...useFacilityCourseNoun_facility\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment useFacilityCourseNoun_facility on Facility {\n  copyOverrides {\n    course {\n      singular\n      plural\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f0f8206449ef3fc3b14612dc3d305865";

export default node;
